import React from 'react';
import { graphql } from 'gatsby';
import { OmRefinedPillarCard } from '@om/component-library-react';

const RefinedPillarCard = ({
    refinedPillarCardContent,
    slot,
    isLandscape,
    isExtended,
}) => {
    if(!refinedPillarCardContent) {
        return '';
    }

    const {
        image_url,
        button_action_type,
        button_text,
        button_url,
        button_disabled,
        title_slot,
        text_body_slot,
        icon_name,
        call_me_back,
        open_tab,

    } = refinedPillarCardContent;

    return (
        <OmRefinedPillarCard
            slot={slot}
            iconName={icon_name}
            imageUrl={image_url.url}
            buttonText={button_text}
            buttonUrl={button_url ? button_url.href: ''}
            buttonDisabled={button_disabled}
            buttonActionType={button_action_type}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            openTab={open_tab}
            isLandscape={isLandscape}
            isExtended={isExtended}

        >
            {
                title_slot ? <span slot="title-slot" dangerouslySetInnerHTML={{__html: title_slot}} /> : ''
            }
            {
                text_body_slot ? <span slot="text-body-slot" dangerouslySetInnerHTML={{__html: text_body_slot}} /> : ''
            }
        </OmRefinedPillarCard>
    );
};

export const pageQuery = graphql`

fragment RefinedPillarCard on Contentstack_refined_pillar_card {
    uid
    image_url {
        ...File
    }
    button_action_type
    button_text
    button_url {
        ...Link
    }
    button_disabled
    title_slot
    text_body_slot
    icon_name,
    call_me_back {
        ...CallMeBack
    }
    open_tab
}
`;

export default RefinedPillarCard